import { render, staticRenderFns } from "./QuoteCommunicationEmailModal.vue?vue&type=template&id=7efb72f2&scoped=true"
import script from "./QuoteCommunicationEmailModal.vue?vue&type=script&lang=js"
export * from "./QuoteCommunicationEmailModal.vue?vue&type=script&lang=js"
import style0 from "./QuoteCommunicationEmailModal.vue?vue&type=style&index=0&id=7efb72f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efb72f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7efb72f2')) {
      api.createRecord('7efb72f2', component.options)
    } else {
      api.reload('7efb72f2', component.options)
    }
    module.hot.accept("./QuoteCommunicationEmailModal.vue?vue&type=template&id=7efb72f2&scoped=true", function () {
      api.rerender('7efb72f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteCommunicationEmailModal.vue"
export default component.exports